__turbopack_context__.v({
  "aend": "funcionalidades-module__DmmOlG__aend",
  "aendN": "funcionalidades-module__DmmOlG__aendN",
  "aendS": "funcionalidades-module__DmmOlG__aendS",
  "aendSok": "funcionalidades-module__DmmOlG__aendSok",
  "aendSup": "funcionalidades-module__DmmOlG__aendSup",
  "aic": "funcionalidades-module__DmmOlG__aic",
  "aicC": "funcionalidades-module__DmmOlG__aicC",
  "aicL": "funcionalidades-module__DmmOlG__aicL",
  "aicR": "funcionalidades-module__DmmOlG__aicR",
  "ainfo": "funcionalidades-module__DmmOlG__ainfo",
  "ask": "funcionalidades-module__DmmOlG__ask",
  "atag": "funcionalidades-module__DmmOlG__atag",
  "atagK": "funcionalidades-module__DmmOlG__atagK",
  "atagP": "funcionalidades-module__DmmOlG__atagP",
  "aud": "funcionalidades-module__DmmOlG__aud",
  "auds": "funcionalidades-module__DmmOlG__auds",
  "bar": "funcionalidades-module__DmmOlG__bar",
  "card": "funcionalidades-module__DmmOlG__card",
  "cardshadow": "funcionalidades-module__DmmOlG__cardshadow",
  "cardwrap": "funcionalidades-module__DmmOlG__cardwrap",
  "chart": "funcionalidades-module__DmmOlG__chart",
  "chip": "funcionalidades-module__DmmOlG__chip",
  "dot": "funcionalidades-module__DmmOlG__dot",
  "dotOn": "funcionalidades-module__DmmOlG__dotOn",
  "eyebrow": "funcionalidades-module__DmmOlG__eyebrow",
  "flow": "funcionalidades-module__DmmOlG__flow",
  "g": "funcionalidades-module__DmmOlG__g",
  "gr": "funcionalidades-module__DmmOlG__gr",
  "h2": "funcionalidades-module__DmmOlG__h2",
  "hero": "funcionalidades-module__DmmOlG__hero",
  "heroL": "funcionalidades-module__DmmOlG__heroL",
  "heroRow": "funcionalidades-module__DmmOlG__heroRow",
  "heroV": "funcionalidades-module__DmmOlG__heroV",
  "ins": "funcionalidades-module__DmmOlG__ins",
  "insDn": "funcionalidades-module__DmmOlG__insDn",
  "insIc": "funcionalidades-module__DmmOlG__insIc",
  "insUp": "funcionalidades-module__DmmOlG__insUp",
  "insights": "funcionalidades-module__DmmOlG__insights",
  "kpi": "funcionalidades-module__DmmOlG__kpi",
  "kpiL": "funcionalidades-module__DmmOlG__kpiL",
  "kpiV": "funcionalidades-module__DmmOlG__kpiV",
  "kpiVp": "funcionalidades-module__DmmOlG__kpiVp",
  "kpis": "funcionalidades-module__DmmOlG__kpis",
  "kw": "funcionalidades-module__DmmOlG__kw",
  "kwIf": "funcionalidades-module__DmmOlG__kwIf",
  "kwThen": "funcionalidades-module__DmmOlG__kwThen",
  "link": "funcionalidades-module__DmmOlG__link",
  "mail": "funcionalidades-module__DmmOlG__mail",
  "mcpb": "funcionalidades-module__DmmOlG__mcpb",
  "mglyph": "funcionalidades-module__DmmOlG__mglyph",
  "nav": "funcionalidades-module__DmmOlG__nav",
  "nic": "funcionalidades-module__DmmOlG__nic",
  "nicClaude": "funcionalidades-module__DmmOlG__nicClaude",
  "node": "funcionalidades-module__DmmOlG__node",
  "phead": "funcionalidades-module__DmmOlG__phead",
  "pkt": "funcionalidades-module__DmmOlG__pkt",
  "pr": "funcionalidades-module__DmmOlG__pr",
  "pulse": "funcionalidades-module__DmmOlG__pulse",
  "q": "funcionalidades-module__DmmOlG__q",
  "ract": "funcionalidades-module__DmmOlG__ract",
  "rbolt": "funcionalidades-module__DmmOlG__rbolt",
  "rcond": "funcionalidades-module__DmmOlG__rcond",
  "res": "funcionalidades-module__DmmOlG__res",
  "resLn": "funcionalidades-module__DmmOlG__resLn",
  "rhead": "funcionalidades-module__DmmOlG__rhead",
  "ric": "funcionalidades-module__DmmOlG__ric",
  "ricDn": "funcionalidades-module__DmmOlG__ricDn",
  "ricPa": "funcionalidades-module__DmmOlG__ricPa",
  "ricUp": "funcionalidades-module__DmmOlG__ricUp",
  "rinfo": "funcionalidades-module__DmmOlG__rinfo",
  "rlog": "funcionalidades-module__DmmOlG__rlog",
  "rlogB": "funcionalidades-module__DmmOlG__rlogB",
  "rlogo": "funcionalidades-module__DmmOlG__rlogo",
  "rsw": "funcionalidades-module__DmmOlG__rsw",
  "rule": "funcionalidades-module__DmmOlG__rule",
  "rules": "funcionalidades-module__DmmOlG__rules",
  "section": "funcionalidades-module__DmmOlG__section",
  "slide": "funcionalidades-module__DmmOlG__slide",
  "slideOn": "funcionalidades-module__DmmOlG__slideOn",
  "sp": "funcionalidades-module__DmmOlG__sp",
  "spin": "funcionalidades-module__DmmOlG__spin",
  "spot": "funcionalidades-module__DmmOlG__spot",
  "stage": "funcionalidades-module__DmmOlG__stage",
  "sub": "funcionalidades-module__DmmOlG__sub",
  "sy": "funcionalidades-module__DmmOlG__sy",
  "sys": "funcionalidades-module__DmmOlG__sys",
  "tbody": "funcionalidades-module__DmmOlG__tbody",
  "term": "funcionalidades-module__DmmOlG__term",
  "thead": "funcionalidades-module__DmmOlG__thead",
  "theadM": "funcionalidades-module__DmmOlG__theadM",
  "theadOn": "funcionalidades-module__DmmOlG__theadOn",
  "theadT": "funcionalidades-module__DmmOlG__theadT",
  "ti": "funcionalidades-module__DmmOlG__ti",
  "txt": "funcionalidades-module__DmmOlG__txt",
  "txtH3": "funcionalidades-module__DmmOlG__txtH3",
  "txtP": "funcionalidades-module__DmmOlG__txtP",
  "vi": "funcionalidades-module__DmmOlG__vi",
  "wire": "funcionalidades-module__DmmOlG__wire",
  "wireLine": "funcionalidades-module__DmmOlG__wireLine",
  "wrap": "funcionalidades-module__DmmOlG__wrap",
});
